const STORAGE_PREFIX = "hr_public_lds_checkout_idempotency_v1:";

function storageKey({ siteId, dealId, depDate, retDate }) {
  return `${STORAGE_PREFIX}${String(siteId || "").trim()}|${String(dealId || "").trim()}|${String(
    depDate || ""
  ).trim()}|${String(retDate || "").trim()}`;
}

function randomKey() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `idemp_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreatePublicLdsCheckoutIdempotencyKey(ctx = {}) {
  const key = storageKey(ctx);
  try {
    if (typeof sessionStorage !== "undefined") {
      const existing = sessionStorage.getItem(key);
      if (existing && String(existing).trim()) return String(existing).trim();
      const created = randomKey();
      sessionStorage.setItem(key, created);
      return created;
    }
  } catch {
    /* private mode */
  }
  return randomKey();
}
